import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {COST_DOCUMENTATION_TYPE_ERROR_MESSAGE, TR} from "./constants";
import moment from "moment";
const fileDateFormat = moment().format("DD/MM/Y");
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: {
          title: "Masraf",
          cost: "Expense",
          panel: "Panel",
          logExpense: "Log Expense",
          expenseMonitoring: "Expense Monitoring",
          managerApproval: "Manager Approval",
          accountingApproval: "Accounting Approval",
          reports: "Reports",
          submitExpensesForApproval: "Submit expenses for approval.",
          total: "Total",
          approved: "Approved",
          pendingCost: "Pending",
          yourManagers: "Your Managers",
          logOut: "Log Out",
          datassistPayrollService: "Datassist Payroll Service",
          uploadedPhotos: "Uploaded photos",
          saveCost: "SAVE EXPENSE",
          other: "Other",
          update: "Update",
          removeCost: "Remove Cost",
          removePhoto: "Remove Photo",
          photoIsNotUploadded: "Photo is not uploaded.",
          all: "All",
          transactions: "Transactions",
          managerNotDefined: "You don't have any manager defined.",

          // Cost Entry Form
          costDate: "Expense Date",
          invoiceReceiptNo: "Invoice / Receipt No",
          costType: "Expense Type",
          selectAnCostType: "Select an expense type",
          costDocumentationType: "Cost Documentation Type",
          selectCostDocumentationType: "Select cost documentation type",
          costAmount: "Expense Amount",
          currencyUnit: "Currency Unit",
          selectCurrencyUnit: "Select currency unit.",
          paymentType: "Payment Type",
          selectPaymentType: "Select payment type.",
          vatRate: "VAT Rate",
          selectVatRate: "Select the VAT rate",
          supplierName: "Supplier Name",
          description: "Description",
          enterProvinceAndReasonForExpense:
            "Please, Enter the Province and Reason for the Expense",
          addPhoto: "Add Photo",

          //Sumiagro Entry Form
          costFormType: "Cost Form Type",
          chooseCostFormType: "Choose Cost Form Type",
          preApprovedBudget: "Pre-approved Budget",
          actualExpenditure: "Actual Expenditure",
          company: "Company",
          place: "Place",
          guests: "Guests",
          guestNumber: "Number of Guests",
          staff: "Staff Name (SAT side)",
          staffNumber: "Number of Staff (SAT side)",
          otherParticipants: "Other Participants",
          otherParticipantNumber: "Number of Other Participants",

          // Costs
          awaitingApproval: "Pending Approval",
          expensesPendingSubmission: "Expenses Pending Submission",
          approvedCosts: "Approved",
          rejects: "Rejects",
          selectYear: "Select year.",
          expenses: "Expenses",
          invoice: "Invoice",
          amount: "Amount",
          status: "Status",
          checkAwaitingApproval: "Check Pending Approval",
          edit: "Edit",
          awaitingConfirmationForCancellation:
            "Pending confirmation/check for cancellation.",
          costDescription: "Cost description",

          // Manager Approval
          selectPersonnel: "Select personnel",
          employee: "Employee",
          employeeId:'Employee ID',
          employmentId:"Employment ID",
          perSicilNo:"Employee Registration Number",
          creationDate: "Creation Date",

          //REPORTS
          reportName: "Cost-Report",
          filterReport: "Filter Report",
          selectStatus: "Select Status.",
          startDate: "Start Date",
          endDate: "End Date",
          bring: "Bring",
          reportInfoMessage:
            "The report is being prepared. This process may take a while. Please wait...",
          totalAmount: "Total amount",
          // Cost Detail
          costDetail: "Cost Detail",
          invoiceNo: "Invoice No",
          costCategory: "Cost Category",
          selectCostCategory: "Select cost category.",
          costBrand: "Cost Brand",
          selectCostBrand: "Select cost brand.",
          costDepartment:"Department",
          selectCostDepartment:"Select department ",
          photos: "Photos",
          reasonForCancellation: "Reason for cancellation",
          revisions: "Revisions",
          notUpdatedData: "No data has been updated.",
          back: "Back",
          revisedCost: "Revised Cost",
          costPhotoExist: "Cost photo exists.",
          costPhoto: "Cost Photo",
          totalRevision:
            "There are <span>{{length}}</span> revisions in total.",
          approvedRejectedDate:
            '{{transactionType}} the cost on <span className="cost-date">{{date}} {{time}} </span> ',
          approvedTransactions:'approved',
          rejectedTransactions: 'rejected',
          reasonOfTheRejected:'Reason of the rejected',
          costKind: "Cost Kinds",
          managerNameAndSurname: "Manager Name Surname",
          managerApprovalDate:"Manager Approval Date",
          uniqCode: "uniqCode",

          //Warnings
          sessionExpired: "Your session has expired. Please login again",

          // Help
          help: "Help",
          helpDownloadDescription:
            'You can download the cost module help document from <a target="_blank" href={{yardimPdf}}>here</a.<br /><br />',
          helpDocumentNotDefined: "Help document is not defined.",

          // Money Type
          tl: "Turkish Lira",
          dollar: "Dollar",
          euro: "Euro",
          sterling: "Sterling",
          dkk:  "Danis Kroner",
          sek:  "Swedish Kroner",
          jpy:  "Japanese Yen",
          AUD	: "Australian Dollar",
          CHF	: "Swiss Franc",
          CAD	: "Canadian Dollar",
          KWD	: "Kuwaiti Dinar",
          NOK	: "Norwegian Krone",
          SAR	: "Saudi Riyal",
          BGN	: "Bulgarian Lev",
          RON	: "Romanian Leu",
          RUB	: "Russian Ruble",
          IRR	: "Iranian Rial",
          CNY	: "Yuan Renminbi",
          PKR	: "Pakistan Rupee",
          QAR	: "Qatari Rial",
          KRW	: "Won",
          AZN	: "Azerbaijanian Manat",
          AED	: "UAE Dirham",

          //Month
          selectMonth: "Select month.",
          jan: "January",
          feb: "February",
          mar: "March",
          apr: "April",
          may: "May",
          jun: "June",
          jul: "July",
          aug: "August",
          sep: "September",
          oct: "October",
          nov: "November",
          dec: "December",

          //Operations
          approveCost: "Approve Cost",
          rejectCost: "Reject Cost",
          approveAll: "Approve All",

          //Pagination
          previousPage: "Previous Page",
          first: "First",
          last: "Last",
          nextPage: "Next page",

          //WorkBook
          export: "Export",
          documentNo: "Document No",
          transactionDate: "Transaction Date",
          vatAmount: "VAT Amount",
          costTaxBase: "Masraf Matrahı",
          downloadAllPDF: "Download All PDF",
          accountingApprovalDate: "Accounting Approval Date",
          costCenter: "Cost Center",
          //Swal
          startDateAlert: "Start Date cannot be greater than End Date ",
          dateRequiredAlert: "Start Date and End Date are required.",
          uploaded: "Uploaded",
          couldNotUploaded: "The file could not be uploaded",
          DOWNLOADING_TITLE: "Downloading.",
          PLEASE_WAIT_TITLE: "Please wait.",
          PDF_DOWNLOADING_MESSAGE: "PDF is downloading, please wait.",
          INFORMATION_UPDATE_MESSAGE: "Your information is updating",
          COST_UPDATE_MESSAGE: "Your cost is updating.",
          COST_ADDING_MESSAGE: "Your cost added",
          COST_CONFIRMING_MESSAGE: "Costs is approved",
          COST_AMOUNT_ERROR_MESSAGE: "Please enter the cost amount.",
          COST_EMPTY_FIELD_ERROR_MESSAGE: "Please don't leave fields empty.",
          form_index: "Cost Form {{index}} : ",
          PDF_FILE_NAME: `-${fileDateFormat}-Cost-Request-Form.pdf`,
          SWAL_ERROR_TITLE: "ERROR!",
          SWAL_SUCCESS_TITLE: "SUCCESS!",
          UNKNOWN_ERROR_MESSAGE: "An error was encountered, please try again",
          COST_PHOTO_DELETE_SUCCESS: "Photo removed",
          OPERATION_PROCESSING: "Operation processing.",
          COST_CREATED_SUCCESS: "Cost created.",
          COST_CREATED_ERROR: "Cost couldn't created, plesase try it again.",
          PHOTO_FIND_ERROR: "Photo couldn't find.",
          COST_AMOUNT_CANT_LESS_THAN_ZERO: "Cost amount cant less than zero.",
          LOADING_PHOTO_ERROR: "An error occured when loading.",
          COST_APPROVED: "Cost approved.",
          UPDATE_ERROR: "Failed to update!!",
          COST_UPDATED: "The cost updated.",
          UPDATE_COST_ERROR: "Failed to update cost.",
          COST_SUBMIT_APPROVAL_ERROR:
            "Cost couldn't be submitted for approval.",
          COST_SUBMIT_APPROVAL_SUCCESS: "Cost submitted for approval.",
          CANT_UPDATE_AFTER_APPROVED:
            "You cannot update your cost after the accounting has been confirmed.",
          COST_FIND_ERROR: "Cost not found.",
          COST_CANCEL_REQUEST_SUCCESS:
            "Your cost cancel request has been successfully completed.",
          OPERATION_ERROR:
            "The operation couldn't be performed, please try again.",
          OPERATION_SUCCESS: "The operation performed.",
          COST_DELETE_SUCCESS: "Cost deleted.",
          COST_DELETE_ERROR: "Cost couldn't delete, please try again.",
          COMPLETED_COST_CANT_DELETE:
            "It's not possilbe to delete the cost after accounting has approved.",
          COST_NOT_EXIST:
            "The cost you wanted to submit for approval could not be found",
          MANAGER_NOT_EXİST: "The manager doesn't exist.",
          COST_REJECTED: "Cost rejected.",
          FILE_UPLOAD_ERROR: "The file couldn't upload, please try again.",
          FILE_NOT_SUPPORTED: "The file you uploaded is not supported.",
          COST_PHOTO_FIND_FAIL: "Cost photo not found!",
          COST_DATE_OLD: "The cost days can't be more than {{day}} days.",
          COST_DATE_OVER: "The cost days can't be more than {{day}} days.",
          COST_DATE_CONTROL_WARNING:
            "The cost month you enter must be the same as the first cost month.",
            areYouSure: "Are you sure?",
            costFormWillRejected:"This cost will be rejected, are you sure?",
            costFormWillCancelled:"This cost will be cancelled, are you sure?",
            enterDescription:"Enter description.",
            doNotLeaveDescriptionEmpty: "Description can not be empty.",
            yes: "Yes",
            no: "No",
            cancelButton: "Cancel",

          //Status
          manager: "Pending for Control / Approval",
          accounting: "Pending accounting payment.",
          accountingCancel: "Rejected by Accounting",
          pending: "Pending for you to submit for approval.",
          cancel: "Rejected by manager.",
          completed: "Completed.",
          waiting: "Waiting",
          rejectedByManager: "Your cost rejected by your manager.",
          costCompleted: "Your cost completed.",

          //Exchange Rate
          currencyInformation: "Currency Information",
          changeExchangeRate: "Change the exchange rate",
          note: "Note",
          currencyNote: "Registered exchange rate information of the relevant expense",
          exchangeTCMB: "<strong>The current exchange rate</strong> information has taken from <strong>Central Bank of Turkey Republic</strong>",
          approve: "Approve",
          close: "Close",

          //Constant Error Messages
          COST_DATE_ERROR_MESSAGE : 'Select an Cost Date.' ,
          COST_INVOICE_NO_ERROR_MESSAGE :  'Enter Invoice / Receipt No.',
          COST_TYPE_ERROR_MESSAGE :  'Select an Cost Type.',
          COST_MONEY_TYPE_ERROR_MESSAGE :  'Select an Currency Unit.',
          COST_PAYMENT_TYPE_ERROR_MESSAGE :  'Select an Payment Type.',
          COST_BRAND_ERROR_MESSAGE :  'Enter the Cost Brand.',
          COST_DEPARTMENT_ERROR_MESSAGE :  'Enter the Department.',
          COST_SUPPLIER_NAME_ERROR_MESSAGE :  'Enter the Supplier Name.',
          COST_CATEGORY_ERROR_MESSAGE :  'Enter the Cost Category.',
          COST_DOCUMENTATION_TYPE_ERROR_MESSAGE:'Enter the Cost Documentation Type.',
          COST_LOCATION_ERROR_MESSAGE :  'Enter the Cost Location.',
          COST_DESCRIPTION_ERROR_MESSAGE :  'Enter the Description.',
          COST_KDV_ERROR_MESSAGE :  'Select and VAT Rate.' ,
          COST_PHOTO_ERROR_MESSAGE :  'Upload the relational expense photo.' ,
          COST_FUTURE_DATED_ERROR_MESSAGE: 'You cannot provide a future-dated expense entry.',

          // SUMIAGRO FORM EMPTY FIELD WARNING MESSAGE
          COST_COMPANY_NAME_ERROR_MESSAGE : 'Enter the Company Name.',
          COST_PLACE_NAME_ERROR_MESSAGE : 'Enter the Place Information.',
          COST_GUEST_NAME_ERROR_MESSAGE : 'Enter the Guests.',
          COST_GUEST_NUMBER_ERROR_MESSAGE :'Enter te Number of Guests.',
          COST_STAFF_NAME_ERROR_MESSAGE : 'Enter the Staff Name (SAT side).',
          COST_STAFF_NUMBER_ERROR_MESSAGE : 'Enter the Number of Staff (SAT side).',
          COST_OTHER_PARTICIPANT_ERROR_MESSAGE : 'Enter the Other Participants.',
          COST_OTHER_PARTICIPANT_NUMBER_ERROR_MESSAGE : 'Enter the Number of Other Participants.',
          COST_ACTUAL_EXPENDITURE_ERROR_MESSAGE : 'Enter the Actual Expenditure Amount.',
        },
      },
      //----------------------------------------
      //----------------------------------------
      tr: {
        translation: {
          title: "Masraf",
          cost: "Masraf",
          panel: "Panel",
          logExpense: "Masraf Girişi",
          expenseMonitoring: "Masraf Görüntüleme",
          managerApproval: "Yönetici Onayı",
          accountingApproval: "Muhasebe Onayı",
          reports: "Raporlar",
          submitExpensesForApproval: "Girdiğim Masrafları Onaya Gönder.",
          total: "Toplam",
          approved: "Onaylanan",
          pendingCost: "Bekleyen",
          yourManagers: "Yöneticileriniz",
          logOut: "Çıkış",
          datassistPayrollService: "Datassist Bordro Servisi",
          uploadedPhotos: "Yüklenen fotoğraflar",
          saveCost: "MASRAFI KAYDET",
          other: "Diğer",
          update: "Güncelle",
          removeCost: "Masafı Sil",
          removePhoto: "Fotoğrafı Sil",
          photoIsNotUploadded: "Fotoğraf yüklenmemiş.",
          all: "Hepsi",
          transactions: "İşlemler",
          managerNotDefined: "Bağlı olduğunuz bir yönetici bulunmuyor.",

          // Cost Entry Form
          costDate: "Masraf Tarihi",
          invoiceReceiptNo: "Fatura / Fiş No",
          costType: "Masraf Türü",
          costDocumentationType:"Masraf Belge Tipi",
          selectCostDocumentationType:"Maraf belge tipi seçin",
          selectAnCostType: "Masraf türü seçin.",
          costAmount: "Masraf Tutarı",
          currencyUnit: "Para Birimi",
          selectCurrencyUnit: "Para birimini seçin.",
          paymentType: "Ödeme Tipi",
          selectPaymentType: "Ödeme tipi seçin.",
          vatRate: "KDV oranı",
          selectVatRate: "KDV oranı seçin",
          supplierName: "Tedarikçi Adı",
          description: "Açıklama",
          enterProvinceAndReasonForExpense:
            "Masraf yapmış olduğunuz il ve gerekçesini giriniz.",
          addPhoto: "Fotoğraf ekleyin",

          //Sumiagro Entry Form
          costFormType: "Masraf Form Tipi",
          chooseCostFormType: "Masraf tipi seçin.",
          preApprovedBudget: "Ön Onay Masraf Tutarı",
          actualExpenditure: "Asıl Harcama Tutarı",
          company: "Şirket",
          place: "Yer/Mekan",
          guests: "Misafirler",
          guestNumber: "Misafir Sayısı",
          staff: "Personel İsmi (SAT)",
          staffNumber: "Personel Sayısı (SAT)",
          otherParticipants: "Diğer Katılımcılar",
          otherParticipantNumber: "Diğer Katılımcı Sayısı",

          // Costs
          awaitingApproval: "Onay Bekleyenler",
          expensesPendingSubmission: "Onaya Gönderilecekler",
          approvedCosts: "Onay Verilenler",
          rejects: "Reddedilenler",
          selectYear: "Yıl seçiniz.",
          expenses: "Masraflar",
          invoice: "Fatura",
          amount: "Tutar",
          status: "Durum",
          checkAwaitingApproval: "Onaya göndermeniz için bekleniyor.",
          edit: "Düzenle",
          awaitingConfirmationForCancellation:
            "İptal için onay/kontrol bekleniyor.",
          costKind: "Masraf Tipi",
          costDescription: "Masraf Açıklaması",

          // Manager Approval
          selectPersonnel: "Personel Seçin",
          employee: "Personel",
          employeeId:"Çalışan ID",
          employmentId:"Çalışma ID",
          perSicilNo:"Personel Sicil No",
          creationDate: "Oluşturma Tarihi",

          //REPORTS
          reportName:"Masraf-Rapor",
          filterReport: "Raporu filtreleyin",
          selectStatus: "Durum seçin.",
          startDate: "Başlangıç Tarihi",
          endDate: "Bitiş Tarihi",
          bring: "Getir",
          reportInfoMessage:
            "Rapor çekiliyor. Bu işlem biraz uzun sürebilir. Lütfen bekleyin...",
          totalAmount: "Toplam Tutar",
          // Cost Detail
          costDetail: "Masraf Detayı",
          invoiceNo: "Fatura No",
          costCategory: "Masraf Kategorisi",
          selectCostCategory: "Masraf kategorisi seçin.",
          costBrand: "Masraf Markası",
          selectCostBrand: "Masraf markası seçin.",
          costDepartment:"Departman",
          selectCostDepartment:"Departman seçin.",
          photos: "Fotoğraflar",
          reasonForCancellation: "İptal nedeni",
          revisions: "Revizeler",
          notUpdatedData: "Herhangi bir veri güncellenmemiş",
          back: "Geri",
          revisedCost: "Revizeli masraf",
          costPhotoExist: "Masraf fotoğrafı bulunuyor.",
          costPhoto: "Masraf Fotoğrafı",
          totalRevision: "Toplamda <span>{{length}}</span> revize bulunuyor.",
          approvedRejectedDate:
            '<span className="cost-date">{{date}} {{time}} </span> tarihinde masrafı {{transactionType}}',
          approvedTransactions:'onayladı',
          rejectedTransactions: 'reddetti',
          reasonOfTheRejected:'Reddedilme Nedeni',
          //Warnings
          sessionExpired: "Oturum süreniz doldu. Lütfen tekrar giriş sağlayın.",
          managerNameAndSurname: "Yönetici Adı Soyadı",
          managerApprovalDate:"Yönetici Onay Tarihi",
          uniqCode: "uniqCode",



          // Help
          help: "Yardım",
          helpDownloadDescription:
            'Masraf modülü yardım dökümanını <a target="_blank" href={{yardimPdf}}>buradan</a> indirebilirsiniz.<br /><br />',
          helpDocumentNotDefined: "Yardım dokümanı tanımlı değil.",

          // Money Type
          tl: "TL",
          dollar: "Dolar",
          euro: "Euro",
          sterlin: "Sterlin",
          dkk:  "Dani̇marka Kronu",
          sek:  "İsveç Kronu",
          jpy:  "Japon Yeni",
          AUD	: "Avustralya Doları",
          CHF	: "İsviçre Frangı",
          CAD	: "Kanada Doları",
          KWD	: "Kuveyt Dinarı",
          NOK	: "Norveç Kronu",
          SAR	: "Suudi Arabistan Riyali",
          BGN	: "Bulgar Levası",
          RON	: "Rumen Leyi",
          RUB	: "Rus Rublesi",
          IRR	: "İran Riyali",
          CNY	: "Çin Yuani",
          PKR	: "Pakistan Rupisi",
          QAR	: "Katar Riyali",
          KRW	: "Güney Kore Wonu",
          AZN	: "Azerbaycan Yeni Manatı",
          AED	: "Birleşik Arap Emirlikleri Dirhemi",
          
          //Month
          selectMonth: "Ay seçiniz.",
          jan: "Ocak",
          feb: "Şubat",
          mar: "Mart",
          apr: "Nisan",
          may: "Mayıs",
          jun: "Haziran",
          jul: "Temmuz",
          aug: "Ağustos",
          sep: "Eylül",
          oct: "Ekim",
          nov: "Kasım",
          dec: "Aralık",

          //Operations
          approveCost: "Masrafı Onayla",
          rejectCost: "Masrafı Reddet",
          approveAll: "Tümünü Onayla",

          //Pagination
          previousPage: "Önceki Sayfa",
          first: "İlk",
          last: "Son",
          nextPage: "Sonraki Sayfa",

          //WorkBook
          export: "Dışarı Aktar",
          documentNo: "Belge No",
          transactionDate: "İşlem Tarihi",
          vatAmount: "KDV Tutarı",
          costTaxBase: "Masraf Matrahı",
          downloadAllPDF: "Toplu Pdf İndir",
          accountingApprovalDate: "Muhasebe Onay Tarihi",
          costCenter: "Masraf Merkezi",
          //Swal
          startDateAlert: "Başlangıç Tarihi Bitiş Tarihinden Büyük Olamaz.",
          dateRequiredAlert: "Başlangıç ve Bitiş Tarihleri Zorunlu Alanlardır.",
          uploaded: "Yüklendi",
          couldNotUploaded: "Dosya yüklenemedi.",
          DOWNLOADING_TITLE: "İndiriliyor",
          PLEASE_WAIT_TITLE: "Lütfen bekleyin",
          PDF_DOWNLOADING_MESSAGE: "PDF indiriliyor, lütfen bekleyin.",
          INFORMATION_UPDATE_MESSAGE: "Bilgileriniz güncelleniyor.",
          COST_UPDATE_MESSAGE: "Masrafınız güncelleniyor",
          COST_ADDING_MESSAGE: "Masraflarınız ekleniyor",
          COST_CONFIRMING_MESSAGE: "Masraflar onaylanıyor.",
          COST_AMOUNT_ERROR_MESSAGE: "Lütfen masraf tutarını giriniz.",
          COST_EMPTY_FIELD_ERROR_MESSAGE: "Lütfen, boş alan bırakmayınız.",
          form_index: "Masraf Formu {{index}} : ",
          PDF_FILE_NAME: `-${fileDateFormat}-Masraf-Talep-Formu.pdf`,
          SWAL_ERROR_TITLE: "HATA!",
          SWAL_SUCCESS_TITLE: "BAŞARILI!",
          UNKNOWN_ERROR_MESSAGE:
            "Bir hata ile karşılaşıldı, lütfen tekrar deneyin.",
          COST_PHOTO_DELETE_SUCCESS: "Fotoğraf silindi.",
          OPERATION_PROCESSING: "İşlem gerçekleştiriliyor.",
          COST_CREATED_SUCCESS: "Masraflar eklendi.",
          COST_CREATED_ERROR: "Masraf eklenemedi, lütfen tekrar deneyin.",
          PHOTO_FIND_ERROR: "Fotoğraf bulunamadı.",
          COST_AMOUNT_CANT_LESS_THAN_ZERO: "Masraf tutarı 0'dan küçük olamaz.",
          LOADING_PHOTO_ERROR: "Resim yüklenirken bir hata oluştu.",
          COST_APPROVED: "Masraf onaylandı.",
          UPDATE_ERROR: "Güncellenemedi!",
          COST_UPDATED: "Masraf güncellendi.",
          UPDATE_COST_ERROR: "Masraf güncellenemedi.",
          COST_SUBMIT_APPROVAL_ERROR: "Masraf onaya gönderilemedi.",
          COST_SUBMIT_APPROVAL_SUCCESS: "Masraf onaya gönderildi.",
          CANT_UPDATE_AFTER_APPROVED:
            "Muhasebe onayladıktan sonra masrafınızı güncelleyemezsiniz.",
          COST_FIND_ERROR: "Masraf bulunamadı!",
          COST_CANCEL_REQUEST_SUCCESS:
            "Masraf iptal talebiniz, başarıyla gerçekleştirildi.",
          OPERATION_ERROR: "İşlem gerçekleştirilemedi, lütfen tekrar deneyin.",
          OPERATION_SUCCESS: "İşlem gerçekleştirildi.",
          COST_DELETE_SUCCESS: "Masraf silindi.",
          COST_DELETE_ERROR: "Masraf silinemedi, tekrar deneyin.",
          COMPLETED_COST_CANT_DELETE:
            "Muhasebe onayladıktan sonra masrafınızı silemezsiniz.",
          COST_NOT_EXIST: "Onaya göndermek istediğiniz masraf bulunamadı.",
          MANAGER_NOT_EXİST: "Yöneticisi bulunmuyor.",
          COST_REJECTED: "Masraf reddedildi.",
          FILE_UPLOAD_ERROR: "Dosya yüklenemedi, lütfen tekrar deneyin.",
          FILE_NOT_SUPPORTED: "Yüklediğiniz dosya desteklenmiyor!",
          COST_PHOTO_FIND_FAIL: "Masraf resmi bulunamadı!",
          COST_DATE_OLD: "{{day}} günü aşmış, masraflar girilemez.",
          COST_DATE_OVER: "{{day}}günden fazla, masraflar girilemez.",
          COST_DATE_CONTROL_WARNING:
            "Girdiğiniz masraf ayı ilk girdiğiniz masraf ayı ile aynı olmalıdır.",
          areYouSure: "Emin misiniz?",
          costFormWillRejected:"Masraf formu onaylanmayacak, emin misiniz?",
          costFormWillCancelled:"Masraf iptal edilecek, emin misiniz?",
          enterDescription:"Açıklama giriniz.",
          doNotLeaveDescriptionEmpty: "Açıklama alanını boş bırakmayın.",
          yes: "Evet",
          no: "Hayır",
          cancelButton: "İptal",
          //Status
          manager: "Kontrol / Onay Bekleniyor",
          accounting: "Muhasebe ödeme bekleniyor.",
          accountingCancel: "Muhasebe onaylamadı.",
          pending: "Onaya göndermeniz için bekleniyor.",
          rejectedByManager: "Yönetici onaylamadı.",
          cancel: "Yönetici onaylamadı.",
          costCompleted: "Masrafınız tamamlandı.",
          completed: "Masrafınız tamamlandı.",
          waiting: "Bekliyor",

          //Exchange Rate
          currencyInformation: "Kur Bilgisi",
          changeExchangeRate: "Döviz kurunu değiştirin",
          note: "Not",
          currencyNote: "İlgili masrafın kayıtlı kur bilgisi",
          exchangeTCMB: "<strong> Türkiye Cumhuriyet Merkez Bankası</strong>'ndaki <strong>güncel kur</strong> bilgisi çekilmiştir.",
          approve: "Onayla",
          close: "Kapat",

          //Constant Error Messages
          COST_DATE_ERROR_MESSAGE : 'Masraf Tarihi seçiniz.',
          COST_INVOICE_NO_ERROR_MESSAGE :  'Fatura / Fiş No alanını giriniz.',
          COST_TYPE_ERROR_MESSAGE :  'Mastaf Türü seçiniz.',
          COST_MONEY_TYPE_ERROR_MESSAGE :  'Para Birimi seçiniz.',
          COST_PAYMENT_TYPE_ERROR_MESSAGE :  'Ödeme Tipi seçiniz.',
          COST_BRAND_ERROR_MESSAGE :  'Masraf Markası alanını giriniz.',
          COST_DEPARTMENT_ERROR_MESSAGE :  'Departman alanını giriniz.',
          COST_SUPPLIER_NAME_ERROR_MESSAGE :  'Tedarikçi Adı alanını giriniz.',
          COST_CATEGORY_ERROR_MESSAGE :  'Masraf Kategori alanını giriniz.',
          COST_DOCUMENTATION_TYPE_ERROR_MESSAGE:'Masraf belge tipini giriniz.',
          COST_LOCATION_ERROR_MESSAGE :  'Masraf Lokasyon alanını giriniz.',
          COST_DESCRIPTION_ERROR_MESSAGE :  'Açıklama alanını giriniz.',
          COST_KDV_ERROR_MESSAGE :  'KDV Oranını seçiniz.' ,
          COST_PHOTO_ERROR_MESSAGE :  'Fotoğraf yükleyiniz.' ,
          COST_FUTURE_DATED_ERROR_MESSAGE: 'İleri tarihli masraf girişi sağlayamazsınız.',

          // SUMIAGRO FORM EMPTY FIELD WARNING MESSAGE
          COST_COMPANY_NAME_ERROR_MESSAGE : 'Şirket alanını giriniz.',
          COST_PLACE_NAME_ERROR_MESSAGE : 'Yer/Mekan alanını giriniz.',
          COST_GUEST_NAME_ERROR_MESSAGE : 'Misafirler alanını giriniz.',
          COST_GUEST_NUMBER_ERROR_MESSAGE :'Misafir Sayısı alanını giriniz.',
          COST_STAFF_NAME_ERROR_MESSAGE : 'Personel İsmi (SAT) alanını giriniz.',
          COST_STAFF_NUMBER_ERROR_MESSAGE : 'Personel Sayısı (SAT) alanını giriniz.',
          COST_OTHER_PARTICIPANT_ERROR_MESSAGE : 'Diğer Katılımcılar alanını giriniz.',
          COST_OTHER_PARTICIPANT_NUMBER_ERROR_MESSAGE : 'Diğer Katılımcı Sayısı alanını giriniz.',
          COST_ACTUAL_EXPENDITURE_ERROR_MESSAGE : 'Asıl Harcama Tutarı alanını giriniz.',
        },
      },
    },
    lng: TR,
    fallbackLng: TR,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
